import React from 'react';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Chip from 'housecall-ui/dist/DesignSystem/DataDisplay/Chip/Chip';
import PropTypes from 'prop-types';
import { CUSTOMER_TYPE } from './TagsData';

const useStyles = makeStyles({
  container: {
    marginTop: 8,
  },
  grid: {
    display: 'flex',
    maxWidth: '100%',
  },
  maxWidth: {
    maxWidth: '100%',
  },
});

const TagChips = ({ tagType, currentTags, deleteTag }) => {
  const { container, maxWidth, grid } = useStyles();

  if (currentTags.length === 0) return null;

  return (
    <Grid container spacing={1} className={container}>
      {currentTags.map((tag) => (
        <Grid key={tag.name} className={grid} item xs="auto">
          {tag.system_tag ? (
            <Chip label={tag.name} />
          ) : (
            <Chip
              data-testid="tag-chip"
              className={maxWidth}
              label={tag.name}
              color={tagType === CUSTOMER_TYPE ? 'success' : 'primary'}
              onDelete={(event) => deleteTag(tagType, tag)}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default TagChips;

TagChips.propTypes = {
  currentTags: PropTypes.array,
  tagType: PropTypes.string,
  deleteTag: PropTypes.func.isRequired,
};

TagChips.defaultProps = {
  currentTags: [],
};
